/** Product identity, injected at build time from product.config.json (vite `define`).
 * Nothing else in the app may spell the name. */
declare const __PRODUCT__: {
  name: string;
  slug: string;
  tagline: Record<string, string>;
  bundleId: string;
};

export const product = __PRODUCT__;

export const storageKey = (k: string): string => `${product.slug}.${k}`;
